import React from 'react'

export const Footer = () => {
  return (
    <>
        <footer>
                <div className="center">
                    <p>Copyright &copy; 2022 || All rights reserved</p>
                </div>
        </footer>
    </>
  )
}
